import React from 'react';

const LiteratureTable = () => {
  const articles = [
    { 
      id: 1, 
      date: "Nov 14", 
      topic: "Melanoma Adjuvant Therapy", 
      relevance: "High", 
      patients: 5 
    },
    { 
      id: 2, 
      date: "Nov 13", 
      topic: "Breast Ca. CDK4/6 Resistance", 
      relevance: "Medium", 
      patients: 3 
    },
    { 
      id: 3, 
      date: "Nov 11", 
      topic: "Colorectal BRAF V600E Combos", 
      relevance: "High", 
      patients: 2 
    }
  ];
  
  return (
    <div className="bg-white rounded-lg shadow mb-6">
      <div className="p-4 border-b">
        <h2 className="text-xl font-medium">Your Practice-Relevant Updates</h2>
      </div>
      
      <table className="min-w-full">
        <thead>
          <tr className="bg-gray-50 border-b">
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Date</th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Topic</th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Relevance</th>
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200">
          {articles.map(article => (
            <tr key={article.id} className="hover:bg-gray-50 cursor-pointer">
              <td className="px-6 py-4 whitespace-nowrap">{article.date}</td>
              <td className="px-6 py-4">{article.topic}</td>
              <td className="px-6 py-4">
                <div className="flex items-center">
                  {article.relevance === "High" && (
                    <span className="text-red-500">★★★ High</span>
                  )}
                  {article.relevance === "Medium" && (
                    <span className="text-orange-500">★★ Medium</span>
                  )}
                  <span className="ml-2 text-gray-500">
                    {article.patients} patients match
                  </span>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default LiteratureTable;